import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { NAV } from "./Header";

// Phone-only bottom navigation (shown below 768px) with the same six sections as
// the header and the mobile app; everything else is a click-through from these.
export default function MobileTabBar({ unread }) {
	const location = useLocation();
	const isActive = (tab) => (tab.match?.some((p) => location.pathname.startsWith(p)) ? true : undefined);

	return (
		<nav className="mobile-tabbar" aria-label="Main">
			{NAV.map((tab) => (
				<NavLink
					key={tab.to}
					to={tab.to}
					end={tab.end}
					className={({ isActive: routeActive }) => `tab-item${(isActive(tab) ?? routeActive) ? " active" : ""}`}
				>
					<span className="position-relative d-inline-flex">
						<tab.icon size={22} />
						{tab.to === "/controls" && unread ? <span className="tab-dot" /> : null}
					</span>
					<span>{tab.label}</span>
				</NavLink>
			))}
		</nav>
	);
}
